import { mapState } from "vuex";
import moment from "moment";
import { PPC_NEW_STRATEGY_WARNING_DAYS } from "@/utils/constants";
export default {
  name: "BrandPortfolioStrategyMixin",
  computed: {
    ...mapState({
      budgetStrategies: state => state.brand_portfolio.budget_strategies
    })
  },
  methods: {
    getWeeklyBudgetFromStrategy(strategy) {
      if (!strategy) return null;
      if (strategy.type === "fixed") return strategy.value ?? null;
      return null;
    },
    getDaysToNewStrategy(endDate, now) {
      if (!endDate) return null;
      const end = moment(endDate, "YYYY-MM-DD", true);
      if (!end.isValid()) return null;
      const startOfToday = moment(now).startOf("day");
      return end.startOf("day").diff(startOfToday, "days");
    },
    getDaysToNewStrategyStatus(daysToNewStrategy) {
      if (daysToNewStrategy === null) return null;
      if (daysToNewStrategy < 0) return "ALERT";
      if (daysToNewStrategy <= PPC_NEW_STRATEGY_WARNING_DAYS) return "WARNING";
      return null;
    },
    computePpcForecastShareOfBudget(forecast, weeklyBudget) {
      if (forecast == null || weeklyBudget == null || weeklyBudget === 0) {
        return null;
      }
      return forecast / weeklyBudget;
    },
    computePpcForecastStatus(forecast, weeklyBudget) {
      if (weeklyBudget == null) return "NO BUDGET";
      const share = this.computePpcForecastShareOfBudget(forecast, weeklyBudget);
      if (share == null) return null;
      if (share < 0.8) return "WARNING";
      if (share >= 1.01) return "ALERT";
      return null;
    },
    budgetStrategyForPortfolio(portfolio) {
      return this.budgetStrategies.find(item => String(item.profile_id) === String(portfolio.profile_id)) ?? null;
    },
    ppcStrategyEndDate(portfolio) {
      return this.budgetStrategyForPortfolio(portfolio)?.end_date ?? null;
    },
    ppcWeeklyBudget(portfolio) {
      const strategy = this.budgetStrategyForPortfolio(portfolio);
      return this.getWeeklyBudgetFromStrategy(strategy?.strategy);
    },
    ppcDaysToNewBudgetStrategy(portfolio) {
      const days = this.getDaysToNewStrategy(this.ppcStrategyEndDate(portfolio), moment());
      return days === null ? null : Math.abs(days);
    },
    ppcDaysToNewBudgetStrategyStatus(portfolio) {
      const days = this.getDaysToNewStrategy(this.ppcStrategyEndDate(portfolio), moment());
      return this.getDaysToNewStrategyStatus(days);
    },
    ppcForecastShareOfBudget(portfolio) {
      return this.computePpcForecastShareOfBudget(portfolio.ppc_forecast, this.ppcWeeklyBudget(portfolio));
    },
    ppcForecastStatus(portfolio) {
      return this.computePpcForecastStatus(portfolio.ppc_forecast, this.ppcWeeklyBudget(portfolio));
    }
  }
};